// extracted by mini-css-extract-plugin
export default {"switch-button":"Supplement_switch-button__i+po5","nav-item":"Supplement_nav-item__33Jzo","content":"Supplement_content__2vEYe"};